import { bylawKind, bylawTooltip } from "../HearingsList/bylaw-kind";
import { RefChip } from "../HearingsList/RefChip";

// City file references — LOC planning application numbers and bylaw
// numbers — using the same .ph-bylaws / .ph-bylaw chip grammar from
// the row so the same hearing reads with the same chip register in
// both surfaces. RefChip carries the CSS-only tooltip.
export function IdentifiersSection({
  locCodes,
  bylawNumbers,
}: {
  locCodes: string[];
  bylawNumbers: string[];
}) {
  if (locCodes.length === 0 && bylawNumbers.length === 0) return null;
  const total = locCodes.length + bylawNumbers.length;

  return (
    <section className="ph-detail-panel" aria-label="City file references">
      <h2 className="ph-detail-panel-l">
        <span>City file references</span>
        <span className="count">{total}</span>
      </h2>
      <div className="ph-bylaws" style={{ marginTop: 0 }}>
        {locCodes.map((l) => (
          <RefChip
            key={`loc-${l}`}
            kind="loc"
            tooltip={`Planning application ${l} — the City file number assigned to this redesignation.`}
          >
            <span className="pre">LOC</span>
            {l.replace(/^LOC/i, "")}
          </RefChip>
        ))}
        {bylawNumbers.map((b) => {
          const kind = bylawKind(b);
          return (
            <RefChip
              key={`bylaw-${b}`}
              kind={kind}
              tooltip={bylawTooltip(b, kind)}
            >
              <span className="pre">bylaw</span>
              {b}
            </RefChip>
          );
        })}
      </div>
    </section>
  );
}
